import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite } from 'gsap';

export default {

    animateIn(SlideFormContainer) {
        let tl = new TimelineLite(),
            ContainerNode = findDOMNode(SlideFormContainer),
            bgImage = ContainerNode.getElementsByClassName('slide-form-bg-img')[0],
            bg = ContainerNode.getElementsByClassName('slide-form-bg')[0],
            headingH2 = ContainerNode.querySelectorAll('.heading h2')[0],
            headingP = ContainerNode.querySelectorAll('.heading p'),
            formRow = ContainerNode.getElementsByClassName('form-row'),
            staggerItems = [headingH2, ...headingP, ...formRow];

        tl.set(document.body, {css: {position: 'fixed'}})
            .set(ContainerNode, {display: 'flex'})
            .fromTo(bgImage, 0.25, {height: 0}, {height: bgImage.style.height})
            .fromTo(bg, 1, {height: 0}, {height: '100%', ease: Power4.easeOut}, 0)
            .staggerFromTo(staggerItems, 0.5, {y: -50, opacity: 0}, {y: 0, opacity: 1}, 0.2, '-=1');
    },

    animateOut(SlideFormContainer) {
        let tl = new TimelineLite(),
            ContainerNode = findDOMNode(SlideFormContainer),
            containerInner = ContainerNode.getElementsByClassName('slide-form-inner')[0];
        
        tl.to(containerInner, 0.5, {y: 0, opacity: 0})
            .to(ContainerNode, 0.75, {height: 0, ease: Power4.easeOut}, '-=0.25')
            .set(ContainerNode, {display: 'none', height: '100vh'}, '-=0.25') //this height should match whatever is in the CSS
            .set(containerInner, {opacity: 1})
            .set(document.body, {css: {position: 'relative'}});
    },

    animateButton(el) {
        let tl = new TimelineLite();
        tl.to(el, 0.2, {scale: 1.3});
        tl.to(el, 0.2, {scale: 1});
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/layout/SlideFormContainer/animations.js